import router from './router';
window._ = require('lodash');

try {
    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.axios.defaults.withCredentials = true;
window.axios.interceptors.response.use({}, error => {
   if( error.response.status === 401 ||  error.response.status === 419 ){
    const token = localStorage.getItem('x_xsrf_token')
    if(token){
        localStorage.removeItem('x_xsrf_token')
    }
     router.push({ name: 'user.login' })
   }
})

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
import Echo from 'laravel-echo';
var ptoken = localStorage.getItem('x_xsrf_token');
if(ptoken && ptoken != ''){

window.Pusher = require('pusher-js');
    window.Echo = new Echo({
        broadcaster: 'pusher',
         key: '21rewfr43',
         cluster: 'mt1',
         forceTLS: true,
         encrypted: true,
         auth: {
            withCredentials: true,
            headers: {
                'X-CSRF-TOKEN': csrfToken
            }
        },
        wsHost: 'lenteres.ru',
        wsPort: 3030,
        wssPort: 3030
    });
}

